import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

/**
 * Склейка классов с разрешением конфликтов Tailwind — та же, что во всех
 * компонентах shadcn/ui.
 *
 * Расширять `twMerge` своими группами здесь не нужно: в `tailwind.config.ts`
 * намеренно нет кастомной шкалы `fontSize`, поэтому известная ловушка
 * («незнакомый `text-t3` вытесняет `text-white`») тут не воспроизводится.
 * Если когда-нибудь появится свой размер шрифта — сюда придёт
 * `extendTailwindMerge`, иначе цвета начнут пропадать выборочно.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
